import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import compact from 'lodash/compact'

import UserAvatar from 'modules/core/components/UserAvatar'
import createMemo from 'modules/core/hooks/createMemo'
import type { Users } from 'modules/core/store/collections/users'
import users from 'modules/core/store/collections/users'

const MAX_AVATARS = 2

const useFilter = createMemo((owners: number[], users: Users) =>
  compact(owners.map((owner) => users.get(owner)))
)
interface OwnersProps {
  owners: number[]
}

const Owners = ({ owners }: OwnersProps) => {
  const filtered = useFilter(owners, users)
  const remaining = filtered.slice(MAX_AVATARS).length

  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      {filtered.slice(0, MAX_AVATARS).map((user) => (
        <UserAvatar user={user} size="s24" key={user.attributes.id} />
      ))}
      {remaining !== 0 && <Text size="200">{`+${remaining}`}</Text>}
    </Box>
  )
}

export default Owners
